<!--
  Copyright (c) 2024-2026 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->

<br/>
<h1 class="page-header">Vehicle Build Compare</h1>
<br/>
@if (permission()) {
    <table class="files-input" [class.hidden]="!showFileInput">
        <tr>
            <td>
                <app-file-upload-card (filesSelected)="onFileSelected($event, 'vehicleBuildFile1')"
                                      [header]="'Vehicle Build:'"
                                      [subheader]="'*Select 1st Vehicle Build file'"></app-file-upload-card>
            </td>
            <td>
                <app-file-upload-card (filesSelected)="onFileSelected($event, 'vehicleBuildFile2')"
                                      [header]="'Vehicle Build:'"
                                      [subheader]="'*Select 2nd Vehicle Build file'"></app-file-upload-card>
            </td>
        </tr>
        <tr>
            <td></td>
            <td>
                <div class="buttons pull-right">
                    <p-button label="Run Report" icon="pi pi-check" class="gm-btn-primary mr-2"
                              [disabled]="!(vehicleBuildFile1 && vehicleBuildFile2) ||
                        !permission()" (click)="runReport()">
                    </p-button>
                </div>
            </td>
        </tr>
    </table>
}
@if (progress() > 0) {
  <p-progressBar mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
}
@if (vehicleBuildCompare) {
  <div>
    <table style="width: 100%;">
      <tr>
        <td> <p-tag severity="secondary" class="mr-2" icon="pi pi-file" value="File 1: {{vehicleBuildFile1.name}}"/>
        <p-tag severity="secondary" class="mr-2" icon="pi pi-file" value="File 2: {{vehicleBuildFile2.name}}"/></td>
        <td>
          <div class="buttons pull-right">
            <p-button icon="pi pi-download" (onClick)="exportReport()"
            label="Download Report" class="gm-btn-primary mr-2"></p-button>
            <p-button label="Change Files" (click)="showFileInput = true; vehicleBuildCompare = null;"
            severity="warn" class="mr-2"></p-button>
          </div>
        </td>
      </tr>
    </table>
    <ag-grid-angular style="width: 100%; height: 80vh;" class="ag-theme-balham"
      [defaultColDef]="defaultColDef" [autoSizeStrategy]="autoSizeStrategy"
      (gridReady)="onGridReady($event)" [rowHeight]="30" [columnDefs]="cols" [rowData]="rowDataSignal()"
    [pagination]="true"></ag-grid-angular>
  </div>
}








